import styles from "../../styles/Writing.module.scss";
import article from "../../assets/article.png";
import rightarrow from "../../assets/rightarrow.svg";

const Writing = () => {
  return (
    <div className={styles.writing}>
      <img src={article} alt="Article title" />
      <div>
        <h6>Open source</h6>
        <p>
          Maybe a few lines to attract the interest of the audience to read your
          blog.
        </p>
        <a
          href="https://riddhisiddarkar.medium.com/open-source-and-why-github-e1742a55de4"
          target="_blank"
          rel="noreferrer"
        >
          <p>
            Read <img src={rightarrow} alt="right arror" />
          </p>
          <p>Feb 16, 2021</p>
        </a>
      </div>
    </div>
  );
};

export default Writing;
